








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Surface, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import ModalOptions from '@/components/Modal/ModalOptions';

import eventBus from '@/utils/eventBus';

import AppOfferPreview from './AppOfferPreview.vue';
import WidgetOfferPreview from './WidgetOfferPreview.vue';
import { CampaignSettings } from '@/components/organisms/OfferFreeCoins/DataPresentation';
import {
  TCustomerLimitType,
  TDeadLineType,
  TVisibilityType
} from '@/models/marketingCenter/freeCoins';
import { pluralize } from '@/utils';

@Component({
  components: {
    Surface,
    Typography,
    FilledButton,
    AppOfferPreview,
    WidgetOfferPreview,
    CampaignSettings
  }
})
export default class OverviewSidebar extends Vue {
  @Prop() coins?: string;
  @Prop() customerLimit?: number;
  @Prop() customerDailyLimit?: number;
  @Prop() customerLimitType?: TCustomerLimitType;
  @Prop() visibilityType?: TVisibilityType;
  @Prop() expiration?: string;
  @Prop() expirationType?: TDeadLineType;
  @Prop() immediateActivation?: string;
  @Prop() onlyNewCustomers?: boolean;
  @Prop() loading?: boolean;

  activeTab = 0;

  openLearnModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'offerFreeCoinsLearnMoreModal',
        false,
        true,
        true
      ),
      { coins: this.coins }
    );
  }

  createCampaign() {
    eventBus.$emit('createNewOfferFreeCoinCampaign');

    this.$emit('save-click');
  }

  handleClickTab(index: number) {
    const tabMapper: Record<number, string> = {
      0: 'App preview',
      1: 'Widget preview'
    };

    this.activeTab = index;

    this.$analytics({
      eventCategory: 'Free Coins Campaign Creation | Preview tabs',
      eventAction: 'click',
      eventLabel: `Clicked on "${tabMapper[index]}" tab`
    });
  }

  get isWidgetAppActive() {
    return (
      this.$store.getters['merchant/getConnectedProviderWithWidgetSettings'] ||
      !this.isMobileAppActive
    );
  }

  get isMobileAppActive() {
    return (
      this.$store.getters['internationalization/getCountrySettings'].status ===
      'full'
    );
  }

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get businessLogo() {
    return this.business.logo.publicPath.small;
  }

  get businessAddress() {
    if (this.business.type === 'online') return this.business.website;

    return this.business.address;
  }

  get buttonText() {
    const coins = Number(this.coins) || 0;

    return `Get ${coins} Free ${pluralize(coins, 'Coin')}`;
  }
}
